import { render, staticRenderFns } from "./PodAppications.vue?vue&type=template&id=6b275834&scoped=true&"
import script from "./PodAppications.vue?vue&type=script&lang=ts&"
export * from "./PodAppications.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b275834",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VDataTable,VDialog,VForm,VImg})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b275834')) {
      api.createRecord('6b275834', component.options)
    } else {
      api.reload('6b275834', component.options)
    }
    module.hot.accept("./PodAppications.vue?vue&type=template&id=6b275834&scoped=true&", function () {
      api.rerender('6b275834', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/rooms/PodAppications.vue"
export default component.exports